export function formatDurationSeconds(seconds) {
  const totalSeconds = Number(seconds);
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return null;

  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;

  if (minutes === 0) return `${remainingSeconds}s`;
  if (remainingSeconds === 0) return `${minutes}m`;
  return `${minutes}m ${remainingSeconds}s`;
}

export function formatDateTime(value, options = {}) {
  const { fallback = "", ...dateTimeOptions } = options;
  if (!value) return fallback;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;

  return new Intl.DateTimeFormat("en-US", dateTimeOptions).format(date);
}

export function formatNullableNumber(value, fallback = null) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return fallback;
  }

  return numericValue.toLocaleString("en-US");
}

export function formatNullableBoolean(value, fallback = null) {
  if (value === null || value === undefined) {
    return fallback;
  }

  return Boolean(value);
}
